import React, { useState } from "react";
import LibrarySong from "./librarySong";
import apiService from "../services/api";

const Library = ({songs,setSongs,setCurentSong,audioRef,isPlaying,libraryStatus})=>{
    
    const [searchSong,setSearchSong] = useState("");
    const [isSearching, setIsSearching] = useState(false);

    const onSearchChange = (e) => {
        setSearchSong(e.target.value);
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        setIsSearching(true);
        const results = await apiService.searchSongs(searchSong);
        setSongs(results);
        setIsSearching(false);
        form.reset();
    };

    return(
        <div className={`library ${libraryStatus ? 'active-library' : '' }`}>
            <h2>Library</h2>
            
            <form className="search-form" onSubmit={handleSubmit}>
                <input className="search-input" type="search"
                    onChange={onSearchChange}
                    name="search"
                    placeholder="Search Song" />
                <button className="search-button" type="submit" id="submit" disabled={isSearching}>
                    {isSearching ? "..." : "Go!"}
                </button>
            </form>

            <div className="library-songs">
                {songs.map((song)=>(
                    <LibrarySong song={song} setSongs={setSongs} key={song?.id} audioRef={audioRef} isPlaying={isPlaying} setCurentSong={setCurentSong}/> 
                ))}
            </div>
        </div>
    )
}

export default Library;